angular.module('am4').factory('viewableMachines', function() {
    var val = [];

    return function(v) {
        if (angular.isDefined(v)) {
            val = v;
        }

        return val;
    };
});



// WEBPACK FOOTER //
// ./src/app/services/viewableMachines.js